import React, { PureComponent } from 'react';
import ReactEcharts from 'echarts-for-react';  // or var ReactEcharts = require('echarts-for-react');
import { descargarChartPng, captionDatosAl, nombreArchivoDesdeTitulo } from '../../commons/utils/chartPng.js';

export default class NightingaleRoseLabels extends PureComponent {
  getOption = () => {
    return this.props.conf;
  };

  // Descarga el gráfico como PNG con el título de la card y la fecha
  // ("datos al …": usa props.fechaDato si está, si no la fecha de hoy).
  descargarPng = () => {
    var inst = (this._echartsComp && typeof this._echartsComp.getEchartsInstance === 'function')
      ? this._echartsComp.getEchartsInstance()
      : null;
    if (!inst) return;
    var titulo = this.props.cardTitle || '';
    descargarChartPng(inst, {
      titulo: titulo,
      caption: captionDatosAl(this.props.fechaDato),
      nombreArchivo: nombreArchivoDesdeTitulo(titulo, 'grafico'),
    });
  };

  render() {
    var self = this;
    return (
      <div className="card pull-up">
        <div className="card-content">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h4 className="card-title mb-0">{this.props.cardTitle}</h4>
            <button
              type="button"
              className="btn btn-sm btn-link p-0 text-muted"
              title="Descargar PNG"
              aria-label="Descargar PNG"
              onClick={this.descargarPng}
            >
              <i className="fa fa-download" aria-hidden="true"></i>
            </button>
          </div>
          <div className="card-body">
            <ReactEcharts
              ref={function(e) { self._echartsComp = e; }}
              option={this.getOption()}
              style={{height: '400px', width: '100%'}}
              className='react_for_echarts'
            />
          </div>
        </div>
      </div>
    );
  }
}
